module.exports = __webpack_public_path__ + "img/tupian.588df1f9.png";